import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from '@ops/shared-types';

export type Language = 'en' | 'jp' | 'sr'; // 'de' | 'sr'

export interface LanguageOption {
  code: Language;
  name: string;
  nativeName: string;
  flag?: string;
}

@Component({
  selector: 'ops-language-switch',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './ops-language-switch.component.html',
  styleUrls: ['./ops-language-switch.component.scss'],
})
export class OpsLanguageSwitchComponent {
  @Input() value: Language = 'en';
  @Output() valueChange = new EventEmitter<Language>();

  private translateService = inject(TranslateService);
  private cookieService = inject(CookieService);

  languageOptions: LanguageOption[] = [
    {
      code: 'en',
      name: 'English',
      nativeName: 'English',
      flag: '🇺🇸',
    },
    {
      code: 'jp',
      name: 'Japanese',
      nativeName: '日本語',
      flag: '🇯🇵',
    },
    // {
    //   code: 'de',
    //   name: 'German',
    //   nativeName: 'Deutsch',
    //   flag: '🇩🇪',
    // },
    {
      code: 'sr',
      name: 'Serbian',
      nativeName: 'Srpski',
      flag: '🇷🇸',
    },
  ];

  onLanguageChange(event: Event) {
    const selectedLanguage = event as unknown as Language;

    if (this.value !== selectedLanguage) {
      this.value = selectedLanguage;

      // Update the translation service
      this.translateService.use(selectedLanguage);

      // Save the language preference to cookies
      this.cookieService.setLanguage(selectedLanguage);

      // Emit the change
      this.valueChange.emit(selectedLanguage);
    }
  }

  getSelectedLanguage(): LanguageOption | undefined {
    return this.languageOptions.find((option) => option.code === this.value);
  }
}
